import type { DetailedHTMLProps, HTMLAttributes } from 'react';
import useOneOnOneStore from '@/lib/zustand/store/oneOnOneStore';
import clsx from 'clsx';
import { DateTimeInterval } from '../types/types';
import { formatLocalTime } from '../utils/helpers';

type TimeProps = {
  time: DateTimeInterval;
} & DetailedHTMLProps<HTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

export default function Time({ time: { start, end }, ...props }: TimeProps) {
  const { timeZone, setSelectedTime } = useOneOnOneStore();
  return (
    <button
      type='button'
      className={clsx(
        'rounded-md border border-brand-primary-border bg-brand-secondary py-2 px-3 shadow-sm transition-all',
        'text-xs font-semibold text-gray-200',
        'hover:bg-slate-700 hocus:shadow-sm hocus:shadow-accent-100 hocus:-mt-0.5 hocus:mb-0.5 hocus:border-accent-500',
        'active:mt-0.5 active:-mb-0.5  outline-accent-600'
      )}
      onClick={() => {
        setSelectedTime({ start, end });
      }}
      {...props}
    >
      {formatLocalTime(start, { timeZone })} – {formatLocalTime(end, { timeZone })}
    </button>
  );
}
